module.exports = __webpack_public_path__ + "fonts/RundigsburgPlain.2a4c46d.ttf";